<template>
  <v-radio-group
    :value="selectedPlan"
    class="info-container"
    @change="$emit('update:selectedPlan', $event)"
    hide-details>
    <div class="main-column">
      <div class="column-header-margin"></div>
      <div class="column-header-cell"></div>
      <div v-for="feature in features" :key="feature.title" class="main column-cell">
        <div class="title-container">
          <div class="feature-title-container">
            <span class="feature-title">{{ feature.title }}</span>
            <v-tooltip bottom max-width="300" transition="fade-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="20" color="disabled-dark">mdi-help-circle-outline</v-icon>
              </template>
              {{ feature.tooltip }}
            </v-tooltip>
          </div>

          <span class="feature-description">{{ feature.description }}</span>
        </div>
        <div v-if="feature.subtitle" class="feature-subtitle">{{ feature.subtitle }}</div>
      </div>
    </div>

    <div v-for="month in planList" :key="month" class="column">
      <div class="column-header-margin" :class="{ 'exist-title': month === highlightMonth }">
        <span v-if="month === 6">사장님들이 <span class="highlight">가장 많이 선택</span>했어요!</span>
      </div>

      <div :class="month === highlightMonth ? 'selected' : 'not-selected'">
        <div class="column-header-cell">
          <div class="d-flex align-center">
            <div class="header-title">
              <span>{{ plans[month].title }}</span>
              <span v-if="plans[month].discount" class="badge">{{ plans[month].discount }}% 할인</span>
            </div>
            <v-radio
              size="32"
              color="primary-light"
              :value="month"
              :ripple="false"
              class="ml-auto custom-radio"></v-radio>
          </div>
          <div class="header-price mt-4">
            <span class="price">{{ plans[month].price }}</span
            ><span class="month">/월</span>
            <span class="vat">VAT 별도</span>
          </div>
          <div class="header-original-price mt-0.5">{{ plans[month].originalPrice }}</div>
        </div>
        <div v-for="feature in plans[month].features" :key="feature.title" class="column-cell">
          <v-icon style="color: black" v-if="feature.type === 'check' && feature.value === true">mdi-check</v-icon>

          <span class="feature-value" v-else-if="feature.type === 'value'"
            >{{ feature.value }} {{ feature.value !== '-' ? unit[feature.title] : '' }}</span
          >
        </div>
      </div>
    </div>
  </v-radio-group>
</template>

<script>
import { STORE_DEAFULT_PLAN_LIST } from '@/constants/ad';

export default {
  name: 'PriceInfo',
  props: {
    selectedPlan: {
      type: Number,
      required: true,
    },
    plans: {
      type: Object,
      required: true,
    },
    features: {
      type: Array,
      required: true,
    },
    unit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      highlightMonth: 6,
      planList: STORE_DEAFULT_PLAN_LIST,
    };
  },

  emits: ['update:selectedPlan'],
};
</script>

<style scoped lang="scss">
.info-container {
  display: flex;

  ::v-deep(.v-input--radio-group__input) {
    flex-direction: row !important;
  }
}

.main-column {
  width: 300px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.column {
  display: flex;
  flex-direction: column;
  flex: 1;

  .selected {
    background: var(--inversed_dark, #fbfbfb);
    border-radius: 16px;
  }
  .not-selected {
    background-color: #fff;
  }
}

.column-header-margin {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  margin-bottom: 8px;
  padding: 8px 16px;
  color: var(--default-dark-color);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */

  &.exist-title {
    border-radius: 12px;
    background: rgba(234, 42, 58, 0.05);
  }

  .highlight {
    color: var(--primary-light-color);
    font-weight: 700;
  }

  @media (max-width: 1026px) {
    height: 52px;
  }
}
.column-header-cell {
  padding: 16px 20px 24px 20px;
  height: 149px;
  position: sticky;
  top: 65px;
  z-index: 10;
  background-color: inherit;
  border-radius: 16px 16px 0 0;

  border-bottom: 1px solid var(--disabled-color);

  @media (max-width: 1000px) {
    height: 191px;
  }
}

.column-cell {
  height: 56px;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--disabled-light-color);

  &.main {
    align-items: flex-start;
  }
}

.title-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.feature-title-container {
  display: flex;
  gap: 4px;
}

.feature-title {
  color: #484848;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
}

.feature-description {
  color: var(--default_light, #808080);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}

.feature-subtitle {
  color: var(--default_light, #808080);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}

.feature-value {
  color: #484848;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
}

.header-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;

  color: var(--default-dark-color);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */

  .badge {
    display: flex;
    padding: 2px 8px;
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
    border-radius: 10px;
    background: var(--tertiary-light-color);

    color: #fff;
    font-family: 'Spoqa Han Sans Neo';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
  }
}

.header-price {
  color: #484848;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  row-gap: 0px;
  column-gap: 8px;

  .price {
    color: var(--default-dark-color);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 133.333% */
  }

  .month {
    color: var(--default-dark-color);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    padding: 2px 0px;
  }

  .vat {
    color: var(--default-light-color);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
    padding: 2px 0px;
  }
}

.header-original-price {
  color: var(--disabled-dark-color);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  text-decoration-line: line-through;
  margin-top: 2px;
  text-decoration: line-through;
}

::v-deep .v-input--selection-controls {
  padding-top: 0px;
  margin-top: 0px;
}

.custom-radio {
  width: 32px;
  height: 32px;

  // v-radio 내부 아이콘 크기 조정
  ::v-deep .v-icon {
    font-size: 32px !important;
    width: 32px !important;
    height: 32px !important;
  }

  // v-radio 선택 영역 크기 조정
  ::v-deep .v-input--selection-controls__input {
    width: 32px !important;
    height: 32px !important;
    margin: 0 !important;
  }

  // v-radio의 ripple 효과 크기 조정
  ::v-deep .v-input--selection-controls__ripple {
    width: 40px !important;
    height: 40px !important;
    left: -4px !important;
    top: calc(50% - 20px) !important;
  }
}
</style>
